export const routes = [
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/pages/Auth/Login.vue'),
    },
    {
      path: '/signup/:cod_agente?',
      name: 'Registro de Usuario',
      component: () => import('@/pages/Auth/Signup.vue')
    },
    {
      path: '/password/email',
      name: 'Recuperar Contraseña',
      component: () => import('@/pages/Auth/PasswordEmail.vue')
    },
    {
      path: '/password/reset/:cod_agente/:token',
      name: 'Generar Nueva Contraseña',
      component: () => import('@/pages/Auth/PasswordGenerate.vue')
    },
    {
      path: '/',
      component: () => import('@/layouts/Default/DefaultContainer.vue'),
      redirect: 'novedades',
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: 'novedades',
          name: 'Novedades',
          component: () => import('@/pages/Novedades/Index.vue')
        },
        {
          path: 'auth/usuarios',
          name: 'Usuarios',
          component: () => import('@/pages/Auth/Usuarios.vue'),
          meta: {
            almostOneRole : true,
            almostAdmin : true,
            almostEmpleadoInterno : false,
          }
        },
        {
          path: 'auth/roles',
          name: 'Roles y Permisos',
          component: () => import('@/pages/Auth/Roles.vue'),
          meta: {
            onlyAdmin: true
          }
        },
        {
          path: 'auth/roles/nuevo',
          name: 'Nuevo Rol',
          component: () => import('@/pages/Auth/NuevoRol.vue')
        },
        {
          path: 'auth/roles/edit/:id',
          name: 'Editar Rol',
          component: () => import('@/pages/Auth/NuevoRol.vue')
        },
        {
          path: 'cartera/consulta',
          name: 'Cartera',
          component: () => import('@/pages/Cartera/Consulta.vue')
        },
        {
          path: 'tomador/:cod_tomador/:asegurado?/:nro_pol/:cod_agente_poliza',
          name: 'Tomador',
          component: () => import('@/pages/Tomador/Tomador.vue')
        },
        {
          path: 'siniestros',
          name: 'Siniestros',
          component: () => import('@/pages/Siniestros/Index.vue')
        },
        {
          path: 'recursos',
          name: 'Recursos',
          component: () => import('@/pages/Recursos/Index.vue')
        },
        {
          path: 'recursos/responsabilidad_civil',
          name: 'Responsabilidad civil',
          component: () => import('@/pages/Recursos/responsabilidad_civil/Index.vue')
        },
        {
          path: 'recursos/responsabilidad_civil/profesionales_salud',
          name: 'Profesionales de la salud',
          component: () => import('@/pages/Recursos/responsabilidad_civil/profesionales_salud.vue')
        },
        {
          path: 'recursos/responsabilidad_civil/ensayos_clinicos',
          name: 'Ensayos clínicos',
          component: () => import('@/pages/Recursos/responsabilidad_civil/ensayos_clinicos.vue')
        },
        {
          path: 'recursos/responsabilidad_civil/armas_fuego',
          name: 'Armas de fuego',
          component: () => import('@/pages/Recursos/responsabilidad_civil/armas_fuego.vue')
        },
        {
          path: 'recursos/responsabilidad_civil/otras_profesiones',
          name: 'Otras profesiones',
          component: () => import('@/pages/Recursos/responsabilidad_civil/otras_profesiones.vue')
        },

        {
          path: 'recursos/personas',
          name: 'Personas',
          component: () => import('@/pages/Recursos/personas/Index.vue')
        },
        {
          path: 'recursos/personas/vida_colectivo',
          name: 'Vida colectivo',
          component: () => import('@/pages/Recursos/personas/vida_colectivo.vue')
        },
        {
          path: 'recursos/personas/accidentes_personales',
          name: 'Accidentes personales',
          component: () => import('@/pages/Recursos/personas/accidentes_personales.vue')
        },
        {
          path: 'recursos/patrimoniales',
          name: 'Personas',
          component: () => import('@/pages/Recursos/patrimoniales/Index.vue')
        },
        {
          path: 'recursos/libros_rubricados',
          name: 'Personas',
          component: () => import('@/pages/Recursos/libros_rubricados/Index.vue')
        },
        {
          path: 'recursos/nomina_asegurados',
          name: 'Nomina',
          component: () => import('@/pages/Recursos/nomina_asegurados/index.vue')
        },
        {
          path: 'recursos/informes',
          name: 'Nomina',
          component: () => import('@/pages/Recursos/informes/index.vue')
        },
        {
          path: 'pas/datos-bancarios',
          name: 'Datos Bancarios PAS',
          component: () => import('@/pages/PAS/datos-bancarios.vue')
        },
        {
          path: 'pas/datos-password',
          name: 'Cambio de Clave PAS',
          component: () => import('@/pages/PAS/cambio-clave.vue')
        },
        {
          path: 'pas/datos-email',
          name: 'Cambiar Correo Electrónico',
          component: () => import('@/pages/PAS/cambio-email.vue')
        },        
        {
          path: 'pas/comisiones',
          name: 'Comisiones',
          component: () => import('@/pages/PAS/comisiones.vue')
        },
        {
          path: 'pas/datos-impositivos',
          name: 'Datos Impositivos PAS',
          component: () => import('@/pages/PAS/datos-impositivos.vue')
        },
        {
          path: 'pas/carga-facturas',
          name: 'Carga Factura Comisiones Pendientes',
          component: () => import('@/pages/PAS/cargarFacturas.vue')
        },
        {
          path: 'recursos/consulta',
          name: 'Recursos.Consulta',
          component: () => import('@/pages/Recursos/Consulta.vue')
        }
      ]
    }
  ];
